import { YOUTUBE_LINKS } from '@common/regexp';

export function wrapYoutubeCodeIntoLink(videoCode: string): string {
    return `https://i.ytimg.com/vi/${videoCode}/maxresdefault.jpg`;
}

/**
 * The video id inside a YouTube link, or `null` when the pattern does not match — which the
 * signature now says out loud. It always could return `null`; declaring `string` merely hid it from
 * every consumer compiled without `strictNullChecks`, and `packages/ai-connector` (which is
 * compiled with it) was the first to notice. The editor's own caller reaches this only after the
 * link has passed validation, so the `null` branch is unreachable there — but a shared helper does
 * not get to assume its callers' guards.
 */
export function getYoutubeVideoCode(url: string): string | null {
    const match = url.match(YOUTUBE_LINKS);
    return match && match[1] ? match[1] : null;
}

/** The numeric id inside a Vimeo link, or `null`. Same note as above about the return type. */
export function getVimeoVideoId(url: string): string | null {
    const match = /vimeo.*\/(\d+)/i.exec(url);

    if (match) {
        return match[1];
    }

    return null;
}
